import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Constants from '../../submodules/logictry_config/constants';
import LogicBaseSearchBar from '../LogicBaseSearchBar';
import IconBadgeDot from '../IconBadgeDot';
import { ChatUnfilledIcon } from '../../styledhtml/Icon';
const DockRoot = styled.div`
  position: fixed;
  z-index: 1;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 1.5rem 1.25rem;
  pointer-events: none;
  box-sizing: border-box;
`;

const DockRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  pointer-events: ${(p) => (p.$hidden ? 'none' : 'auto')};
`;

const SearchSlot = styled.div`
  flex: 1;
  min-width: 0;
`;

const dockChrome = `
  border: 1px solid ${Constants.HairlineBorderRgba};
  background: ${Constants.SurfaceColor};
  box-shadow: ${Constants.isDarkMode ? '0 4px 16px rgba(255, 255, 255, 0.04)' : '0 4px 16px rgba(0, 0, 0, 0.08)'};
`;

const DockIconBtn = styled.button`
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 999px;
  cursor: pointer;
  color: ${Constants.DarkTextColor};
  padding: 0;
  transition: background 0.12s, box-shadow 0.12s;
  ${dockChrome}

  &:active {
    background: ${Constants.SurfaceColor};
    box-shadow: ${Constants.isDarkMode ? '0 2px 10px rgba(255, 255, 255, 0.06)' : '0 2px 10px rgba(0, 0, 0, 0.1)'};
  }
  > * {
    ${Constants.isDarkMode ? 'filter: invert(1);' : ''}
  }
`;

export default function LogicBaseMobileDock({
  onOpenMessages,
  messengerBadge = false,
  hidden = false,
  style,
}) {
  return (
    <DockRoot
      aria-label="Mobile actions"
      aria-hidden={hidden || undefined}
      inert={hidden ? '' : undefined}
      style={style}
    >
      <DockRow $hidden={hidden}>
        <SearchSlot>
          <LogicBaseSearchBar variant="dock" />
        </SearchSlot>
        <DockIconBtn
          type="button"
          title="Messages"
          aria-label="Messages"
          onClick={onOpenMessages}
        >
          <ChatUnfilledIcon style={{ width: 20, height: 20, position: 'relative' }}>
            {messengerBadge && <IconBadgeDot />}
          </ChatUnfilledIcon>
        </DockIconBtn>
      </DockRow>
    </DockRoot>
  );
}

LogicBaseMobileDock.propTypes = {
  onOpenMessages: PropTypes.func.isRequired,
  messengerBadge: PropTypes.bool,
  hidden: PropTypes.bool,
  style: PropTypes.object,
};
